function setAccordionHeight() {
  const acc = document.querySelector('.media-navigation.accordion-menu');
  if (acc) {
    const accContent = acc.querySelector('.accordion-item[aria-expanded="true"] ul.accordion-content');

    if (accContent) {
      acc.classList.add('expanded');
    } else {
      if (acc.classList.contains('expanded')) {
        acc.classList.remove('expanded');
      }
    }
  } else {
    return;
  }
}

function closeAccordionTab() {
  const menu = document.querySelector('.media-navigation.accordion-menu');
  jQuery('.media-navigation.accordion-menu').foundation('up', jQuery('.media-navigation ul.accordion-content'));
  if (menu) {
    menu.classList.remove('expanded');
  }
}

function libraryInit() {
  if (document.querySelector('.accordion-title.show-all')) {
    document.querySelector('.accordion-title.show-all').addEventListener('click', closeAccordionTab);
  }

  const closeTrigger = document.querySelectorAll('.close-accordion');

  closeTrigger.forEach(item => {
    item.addEventListener('click', closeAccordionTab);
  });

  window.addEventListener('resize', setAccordionHeight);

  const trigger = document.querySelectorAll('.media-navigation.accordion-menu .accordion-title');

  trigger.forEach(item => {
    item.addEventListener('click', setAccordionHeight);
  });
}
